<template>
  <div class="report-view">
    <v-row no-gutters class="justify-space-between align-center pa-5" style="padding: 0px 0px 12px 8px !important;">
      <v-col cols="6">
        <div class="title">
          {{dialog?.title || ''}}
          <span v-if="this.amountSelectedReports  > 0">({{ selectedReportsText }})</span>
        </div>
      </v-col>
      <v-col v-if="showActionButton" cols="6" class="d-flex justify-end report-buttons align-center">
        <div class="action-btn-report">
          <ReportDownloadIcon @click="downloadFile" />
        </div>
        <div class="action-btn-report">
          <ReportPrintIcon @click="print"/>
        </div>
        <div class="action-btn-report">
          <ReportSendEmailIcon @click="sendToPatientEmail" />
        </div>
        <div class="language-switcher">
          <Button
            block
            dark
            :class="{ 'active-language': activeLanguage === 'en' }"
            @click="switchLanguage('en')"
            tabindex="3" height="36">
            English
          </Button>
          <Button
            block
            dark
            :class="{ 'active-language': activeLanguage === 'es' }"
            @click="switchLanguage('es')"
            tabindex="3" height="36">
            Spanish
          </Button>
        </div>
      </v-col>
    </v-row>
    <div class="pdf-viewer-container"
         :style="{ height: frameHeight ? frameHeight + 'px' : '590px' }">
      <div class="pdf-canvas-render">
        <vue-pdf-embed
          :key="initialDoc"
          :source="initialDoc"
          class="pdf-render-surface"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/elements/Button'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { trackEvent } from '@/utils/analytics'
import ReportDownloadIcon from '@/assets/icons/components/report-download-icon.svg'
import ReportPrintIcon from '@/assets/icons/components/report-print-icon.svg'
import ReportSendEmailIcon from '@/assets/icons/components/report-send-email-icon.svg'

export default {
  props: {
    activeLanguage: String,
    initialDoc: {
      type: String,
      default: null
    },
    frameHeight: {
      type: String,
      default: null
    },
    showActionButton: {
      type: Boolean,
      default: true
    },
    disabledSpanish: {
      type: Boolean,
      default: false
    },
    fromReceiptPrint: {
      type: Boolean,
      default: false
    },
    isMultipleReports: {
      type: Boolean,
      default: false
    },
    amountSelectedReports: {
      type: Number,
      default: 0
    }
  },
  components: {
    VuePdfEmbed,
    Button,
    ReportDownloadIcon,
    ReportPrintIcon,
    ReportSendEmailIcon
  },
  name: 'reportView',
  data: () => ({
    localInstance: null
  }),
  mounted () {
    if (this.fromReceiptPrint) {
      const self = this
      setTimeout(() => {
        self.print()
      }, 4000)
    }
  },
  methods: {
    async downloadFile () {
      // const blob = Object.keys(this.reportsSurvey).length === 0 ? this.receiptReport : this.reportsSurvey
      if (!this.isMultipleReports) {
        const url = this.initialDoc // window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        document.getElementsByTagName('body')[0].appendChild(link)
        link.href = url
        link.download = 'Report.pdf'

        link.click()
        document.getElementsByTagName('body')[0].removeChild(link)

        trackEvent(this, 'download_report', 'Reports', 'Download Single Report')
      } else {
        trackEvent(this, 'download_report', 'Reports', 'Download Multiple Reports')

        this.$emit('downloadMultipleReports')
      }
    },

    switchLanguage (val) {
      this.$emit('switchLanguage', val)
    },
    renderWebViewer (instance) {
      this.localInstance = instance
    },
    sendToPatientEmail () {
      this.$emit('sendSurveyFormToPatient')
    },
    print () {
      if (!this.initialDoc) {
        console.warn('Print aborted: initialDoc is not set yet', this.initialDoc)
        return
      }

      const oldIframe = document.getElementById('report-print-iframe')
      if (oldIframe) {
        document.body.removeChild(oldIframe)
      }

      const iframe = document.createElement('iframe')
      iframe.id = 'report-print-iframe'

      Object.assign(iframe.style, {
        position: 'absolute',
        top: '-9999px',
        left: '-9999px',
        width: '100%',
        height: '100%',
        border: '0',
        opacity: '0',
      })

      iframe.src = this.initialDoc

      document.body.appendChild(iframe)

      iframe.onload = () => {
        iframe.contentWindow?.focus()
        setTimeout(() => {
          iframe.contentWindow?.print()
        }, 200)

        const cleanUp = () => {
          if (iframe.parentNode) {
            document.body.removeChild(iframe)
          }
          window.removeEventListener('focus', cleanUp)
        }

        iframe.contentWindow?.addEventListener('afterprint', cleanUp)
        window.addEventListener('focus', cleanUp)

        setTimeout(() => {
          cleanUp()
        }, 60000)
      }
      trackEvent(this, 'print_report', 'Reports', 'Print')
    }
  },
  computed: {
    ...mapState({
      dialog (state) {
        const modalName = this._.findKey(state.dialogs, ['isOpen', true])
        return state.dialogs[modalName]
      },
      doctors: state => state.patients?.doctors?.$values,
      model: state => state.visits?.model,
      reportsSurvey: state => state.reports.reportsSurvey,
      receiptReport: state => state.receipts.receiptReport
    }),

    selectedReportsText() {
      const count = this.amountSelectedReports
      if (count === 1) {
        return `${count} report selected`
      } else if (count > 1) {
        return `${count} reports selected`
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.report-view {
  .language-switcher {
    display: flex;
    column-gap: 2px;
    max-width: 182px;
    background-color: #F7FAFC;
    border-radius: 8px;
    padding: 2px;

    .button {
      ::v-deep .v-btn {
        background-color: #F7FAFC !important;
        color: #425466 !important;
        font-weight: 600!important;
        letter-spacing: 0;
        font-size: 12px;
      }
    }
    .button.active-language {
      ::v-deep .v-btn {
        background-color: #008C89 !important;
        color: #fff !important;
        font-size: 12px;
      }
    }
  }
  .title {
    font-weight: 600;
    font-size: 16px !important;
    color: #16192C;
  }
  .btn-text {
    font-weight: 600;
    font-size: 12px;
    color: #16192C;
    padding-left: 6px;
  }
  .report-buttons {
    column-gap: 10px;

    .action-btn-report {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      background-color: #F7FAFC;
      border-radius: 10px;
      padding: 8px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .pdf-viewer-container {
    position: relative;
    width: 100%;
    background-color: #edf2f7;
    overflow: hidden;

    .pdf-canvas-render {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;

      .pdf-render-surface {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 20px 0;

        ::v-deep canvas {
          display: block;
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          margin: 0 auto 20px auto;
        }
      }
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f5f9;
      }
      &::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 10px;
        border: 2px solid #f1f5f9;
      }
    }
  }
}
</style>
